import Modal from './modal.js';

class CertificateForm {
    constructor() {
        this.modal = new Modal('certificateModal');
        this.modalElement = document.getElementById('certificateModal');
        this.form = document.getElementById('certificateForm');
        this.certificatesList = document.getElementById('certificatesList');
        this.certificateInfo = document.getElementById('certificateInfo');
        this.certificatePriceEl = document.getElementById('certificatePrice');
        this.userNameInput = document.getElementById('certificateUserName');
        this.userPhoneInput = document.getElementById('certificateUserPhone');
        this.userEmailInput = document.getElementById('certificateUserEmail');
        this.specialNeedsInput = document.getElementById('certificateSpecialNeeds');
        this.submitBtn = document.getElementById('certificateSubmit');
        this.closeBtn = document.getElementById('certificateModalClose');
        this.errorsContainer = document.getElementById('certificateErrors');
        this.disclaimerCheckbox = document.getElementById('certificateDisclaimer');
        
        this.selectedCertificate = null;
        this.certificates = [];
        this.errors = {};
        
        this.loadCertificates();
        this.init();
    }
    
    init() {
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                this.modal.close();
            });
        }
        
        if (this.userNameInput) {
            this.userNameInput.addEventListener('input', () => {
                this.clearFieldError(this.userNameInput);
            });
        }
        
        if (this.userPhoneInput) {
            this.userPhoneInput.addEventListener('input', (e) => {
                this.formatPhoneInput(e.target);
                this.clearFieldError(this.userPhoneInput);
            });
        }
        
        if (this.userEmailInput) {
            this.userEmailInput.addEventListener('input', () => {
                this.clearFieldError(this.userEmailInput);
            });
        }
        
        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                
                if (this.submitBtn && this.submitBtn.disabled) {
                    return;
                }
                
                this.handleSubmit();
            });
        }
        
        // Открытие модалки по клику на карточку сертификата
        const certificateCardBtn = document.getElementById('certificateCardBtn');
        if (certificateCardBtn) {
            certificateCardBtn.addEventListener('click', () => {
                this.open();
            });
        }
    }
    
    async loadCertificates() {
        try {
            const response = await fetch('/wp-json/pozamezh/v1/certificates');
            if (response.ok) {
                this.certificates = await response.json();
                this.renderCertificates();
            }
        } catch (error) {
            console.error('Error loading certificates:', error);
        }
    }
    
    renderCertificates() {
        if (!this.certificatesList) return;
        
        this.certificatesList.innerHTML = '';
        
        if (this.certificates.length === 0) {
            const noCertMsg = document.createElement('div');
            noCertMsg.className = 'booking-modal__no-slots';
            noCertMsg.textContent = 'Немає доступних сертифікатів';
            this.certificatesList.appendChild(noCertMsg);
            return;
        }
        
        const midPoint = Math.ceil(this.certificates.length / 2);
        const leftColumn = this.certificates.slice(0, midPoint);
        const rightColumn = this.certificates.slice(midPoint);
        
        const leftColumnContainer = document.createElement('div');
        leftColumnContainer.className = 'booking-modal__time-slots-column';
        
        const rightColumnContainer = document.createElement('div');
        rightColumnContainer.className = 'booking-modal__time-slots-column';
        
        leftColumn.forEach((certificate) => {
            const certEl = this.createCertificateElement(certificate);
            leftColumnContainer.appendChild(certEl);
        });
        
        rightColumn.forEach((certificate) => {
            const certEl = this.createCertificateElement(certificate);
            rightColumnContainer.appendChild(certEl);
        });
        
        this.certificatesList.appendChild(leftColumnContainer);
        this.certificatesList.appendChild(rightColumnContainer);
    }
    
    createCertificateElement(certificate) {
        const certEl = document.createElement('label');
        certEl.className = 'booking-modal__time-slot';
        
        const price = parseFloat(certificate.price) || 0;
        const validityDays = parseInt(certificate.validity_days) || 365;
        
        certEl.innerHTML = `
            <input type="radio" 
                   name="certificate" 
                   value="${certificate.id}"
                   data-price="${price}">
            <svg class="booking-modal__checkbox-check" aria-hidden="true">
                <use href="#check"></use>
            </svg>
            <span class="booking-modal__time-slot-label">
                <span class="booking-modal__time-slot-time">${certificate.name}</span>
                <span class="booking-modal__time-slot-places">
                    <span class="booking-modal__time-slot-dot"></span>
                    <span class="booking-modal__time-slot-places-text">${price} ₴ • Дійсний ${validityDays} днів</span>
                </span>
            </span>
        `;
        
        const radio = certEl.querySelector('input[type="radio"]');
        radio.addEventListener('change', (e) => {
            if (e.target.checked) {
                this.selectedCertificate = {
                    id: certificate.id,
                    name: certificate.name,
                    price: price,
                    validity_days: validityDays
                };
                this.updatePrice();
                this.showCertificateInfo();
                this.clearFormError();
            }
        });
        
        return certEl;
    }
    
    showCertificateInfo() {
        if (this.certificateInfo) {
            this.certificateInfo.style.display = 'flex';
            this.certificateInfo.style.visibility = 'visible';
        }
    }
    
    hideCertificateInfo() {
        if (this.certificateInfo) {
            this.certificateInfo.style.display = 'none';
        }
    }
    
    updatePrice() {
        if (!this.selectedCertificate) {
            this.hideCertificateInfo();
            return;
        }
        
        if (this.certificatePriceEl) {
            const price = Math.round(this.selectedCertificate.price);
            this.certificatePriceEl.textContent = `${price} ₴`;
        }
        
        // Убеждаемся, что цена видна
        const priceElement = this.modalElement.querySelector('#certificateInfo .booking-modal__price');
        if (priceElement) {
            priceElement.style.display = 'block';
        }
        
        this.showCertificateInfo();
    }
    
    open() {
        this.resetForm();
        this.modal.open();
        
        if (this.certificates.length === 0) {
            this.loadCertificates();
        }
    }
    
    formatPhoneInput(input) {
        let value = input.value.replace(/\D/g, '');
        
        if (value.startsWith('380')) {
            value = '380' + value.substring(3);
        } else if (value.length > 0 && !value.startsWith('380')) {
            value = '380' + value;
        }
        
        if (value.length > 0) {
            let formatted = '+380 ';
            const rest = value.substring(3);
            
            if (rest.length === 0) {
                formatted = '+380 ';
            } else if (rest.length <= 2) {
                formatted += rest;
            } else if (rest.length <= 5) {
                formatted += `${rest.substring(0, 2)}-${rest.substring(2)}`;
            } else if (rest.length <= 7) {
                formatted += `${rest.substring(0, 2)}-${rest.substring(2, 5)}-${rest.substring(5)}`;
            } else {
                formatted += `${rest.substring(0, 2)}-${rest.substring(2, 5)}-${rest.substring(5, 7)}-${rest.substring(7, 9)}`;
            }
            
            input.value = formatted;
        } else {
            input.value = '';
        }
    }
    
    validateName() {
        const name = this.userNameInput ? this.userNameInput.value.trim() : '';
        
        if (!name || name.length < 2) {
            this.showError(this.userNameInput, 'Будь ласка, введіть ваше ім\'я');
            return false;
        }
        
        this.hideError(this.userNameInput);
        return true;
    }
    
    validatePhone() {
        const phone = this.userPhoneInput ? this.userPhoneInput.value.trim() : '';
        const phoneDigits = phone.replace(/\D/g, '');
        
        if (!phone || phoneDigits.length < 12) {
            this.showError(this.userPhoneInput, 'Будь ласка, введіть правильний номер телефону');
            return false;
        }
        
        this.hideError(this.userPhoneInput);
        return true;
    }
    
    validateEmail() {
        const email = this.userEmailInput ? this.userEmailInput.value.trim() : '';
        
        if (!email) {
            this.showError(this.userEmailInput, 'Email не може бути порожнім');
            return false;
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            this.showError(this.userEmailInput, 'Будь ласка, введіть правильний email');
            return false;
        }
        
        this.hideError(this.userEmailInput);
        return true;
    }
    
    validateForm() {
        let isValid = true;
        this.clearAllErrors();
        
        if (!this.selectedCertificate) {
            isValid = false;
            this.showFormError('Будь ласка, оберіть сертифікат');
        }
        
        if (!this.validateName()) {
            isValid = false;
        }
        
        if (!this.validatePhone()) {
            isValid = false;
        }
        
        if (!this.validateEmail()) {
            isValid = false;
        }
        
        if (!this.disclaimerCheckbox || !this.disclaimerCheckbox.checked) {
            isValid = false;
            this.showFormError('Будь ласка, підтвердіть ознайомлення з правилами');
        }
        
        return isValid;
    }
    
    async handleSubmit() {
        if (!this.validateForm()) {
            return;
        }
        
        if (this.submitBtn) {
            this.submitBtn.disabled = true;
            const spinner = this.submitBtn.querySelector('.btn__spinner');
            const text = this.submitBtn.querySelector('.btn__text');
            if (spinner && text) {
                text.style.visibility = 'hidden';
                spinner.style.display = 'flex';
            }
        }
        
        try {
            const response = await fetch('/wp-json/pozamezh/v1/booking', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    order_type: 'certificate',
                    certificate_id: this.selectedCertificate.id,
                    customer_name: this.userNameInput.value.trim(),
                    customer_phone: this.userPhoneInput.value.trim(),
                    customer_email: this.userEmailInput.value.trim(),
                    special_needs: this.specialNeedsInput ? this.specialNeedsInput.value.trim() : null
                })
            });
            
            const data = await response.json();
            
            if (response.ok) {
                if (data.payment_url) {
                    window.location.href = data.payment_url;
                } else {
                    const errorMessage = data.message || 'Сталася помилка при створенні замовлення. Спробуйте ще раз.';
                    this.showFormError(errorMessage);
                }
            } else {
                const errorMessage = data.message || data.data?.message || 'Сталася помилка при створенні замовлення';
                this.showFormError(errorMessage);
                
                if (this.submitBtn) {
                    this.submitBtn.disabled = false;
                    const spinner = this.submitBtn.querySelector('.btn__spinner');
                    const text = this.submitBtn.querySelector('.btn__text');
                    if (spinner && text) {
                        text.style.visibility = 'visible';
                        spinner.style.display = 'none';
                    }
                }
            }
        } catch (error) {
            console.error('Error submitting certificate order:', error);
            this.showFormError('Сталася помилка при відправці форми. Спробуйте ще раз.');
            
            if (this.submitBtn) {
                this.submitBtn.disabled = false;
                const spinner = this.submitBtn.querySelector('.btn__spinner');
                const text = this.submitBtn.querySelector('.btn__text');
                if (spinner && text) {
                    text.style.visibility = 'visible';
                    spinner.style.display = 'none';
                }
            }
        }
    }
    
    showError(input, message) {
        if (!input || !this.errorsContainer) return;
        
        const fieldName = input.id;
        this.errors[fieldName] = message;
        
        const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
        if (wrapper) {
            wrapper.classList.add('booking-modal__input-wrapper--error');
            
            if (!wrapper.querySelector('.booking-modal__error-icon')) {
                const errorIcon = document.createElement('div');
                errorIcon.className = 'booking-modal__error-icon';
                errorIcon.innerHTML = `
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8" stroke="#ff6b6b" stroke-width="1.5" fill="none"/>
                        <path d="M10 6V10" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M10 14H10.01" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                `;
                wrapper.appendChild(errorIcon);
            }
        }
        
        this.renderErrors();
    }
    
    hideError(input) {
        if (!input || !this.errorsContainer) return;
        
        const fieldName = input.id;
        delete this.errors[fieldName];
        
        const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
        if (wrapper) {
            wrapper.classList.remove('booking-modal__input-wrapper--error');
            const errorIcon = wrapper.querySelector('.booking-modal__error-icon');
            if (errorIcon) {
                errorIcon.remove();
            }
        }
        
        this.renderErrors();
    }
    
    clearFieldError(input) {
        if (!input) return;
        
        const fieldName = input.id;
        if (this.errors[fieldName]) {
            delete this.errors[fieldName];
            
            const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
            if (wrapper) {
                wrapper.classList.remove('booking-modal__input-wrapper--error', 'booking-modal__textarea-wrapper--error');
                const errorIcon = wrapper.querySelector('.booking-modal__error-icon');
                if (errorIcon) {
                    errorIcon.remove();
                }
            }
            
            this.renderErrors();
        }
        
        this.clearFormError();
    }
    
    showFormError(message) {
        if (!this.errorsContainer) return;
        
        const errorEl = document.createElement('div');
        errorEl.className = 'booking-modal__error booking-modal__error--form';
        errorEl.textContent = message;
        this.errorsContainer.appendChild(errorEl);
    }
    
    clearFormError() {
        if (!this.errorsContainer) return;
        
        const formErrors = this.errorsContainer.querySelectorAll('.booking-modal__error--form');
        formErrors.forEach(error => error.remove());
    }
    
    renderErrors() {
        if (!this.errorsContainer) return;
        
        const formErrors = this.errorsContainer.querySelectorAll('.booking-modal__error--form');
        const fieldErrorKeys = Object.keys(this.errors);
        
        if (formErrors.length === 0 && fieldErrorKeys.length === 0) {
            this.errorsContainer.innerHTML = '';
            return;
        }
        
        let html = '';
        
        formErrors.forEach(formError => {
            html += formError.outerHTML;
        });
        
        fieldErrorKeys.forEach(fieldName => {
            const errorEl = document.createElement('div');
            errorEl.className = 'booking-modal__error';
            errorEl.textContent = this.errors[fieldName];
            html += errorEl.outerHTML;
        });
        
        this.errorsContainer.innerHTML = html;
    }
    
    clearAllErrors() {
        if (!this.errorsContainer) return;
        
        this.errors = {};
        this.errorsContainer.innerHTML = '';
        
        const errorWrappers = this.modalElement.querySelectorAll('.booking-modal__input-wrapper--error, .booking-modal__textarea-wrapper--error');
        errorWrappers.forEach(wrapper => {
            wrapper.classList.remove('booking-modal__input-wrapper--error', 'booking-modal__textarea-wrapper--error');
            const errorIcon = wrapper.querySelector('.booking-modal__error-icon');
            if (errorIcon) {
                errorIcon.remove();
            }
        });
    }
    
    resetForm() {
        this.selectedCertificate = null;
        this.hideCertificateInfo();
        this.clearAllErrors();
        
        if (this.form) {
            const certificateRadios = this.form.querySelectorAll('input[name="certificate"]');
            certificateRadios.forEach(radio => {
                radio.checked = false;
            });
        }
        
        if (this.userNameInput) {
            this.userNameInput.value = '';
        }
        
        if (this.userPhoneInput) {
            this.userPhoneInput.value = '';
        }
        
        if (this.userEmailInput) {
            this.userEmailInput.value = '';
        }
        
        if (this.specialNeedsInput) {
            this.specialNeedsInput.value = '';
        }
        
        if (this.disclaimerCheckbox) {
            this.disclaimerCheckbox.checked = false;
        }
    }
}

export default CertificateForm;

